
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.594 18.55L21.052 3.094","stroke":"#E6E7E9","stroke-width":"2","stroke-linecap":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.716 16.675h5.095c3.646 0 7-2.4 7-5.8 0-1.692-.84-3.142-2.127-4.168L20.26 8.13c.986.723 1.55 1.73 1.55 2.745 0 1.902-2.019 3.8-5 3.8h-3.095l-2 2zm4.127-12.612a5.002 5.002 0 00-8.745 2.278 1 1 0 01-.837.804c-2.48.366-4.05 2.038-4.05 3.73 0 1.502 1.258 3 3.254 3.566l-1.55 1.55C1.77 15.044.211 13.192.211 10.874c0-2.79 2.282-4.919 5.084-5.58a7.002 7.002 0 0111.966-2.65l-1.418 1.418z","fill":"#E6E7E9"}})])
          )
        }
      }
    